import React, { useState } from 'react';
import { Box, Button, Loader } from '@wix/design-system';
import { useCredentials } from './useCredentials';
import { Credentials } from './Credentials';
import { oauthConnect } from './connectionTypes/oauthConnect/oauthConnect';
import { directConnect } from './connectionTypes/directConnect';
export const ConnectPaymentProviderWidget = _ref => {
  let {
    data,
    context
  } = _ref;
  const {
    fields,
    paymentProvider,
    paymentMethods,
    connectionType
  } = data;
  const {
    send
  } = context;
  const paymentMethod = paymentMethods[0];
  const hasFields = Boolean(fields && (fields == null ? void 0 : fields.length) > 0);
  const [isConnecting, setIsConnecting] = useState(false);
  const [hasFinished, setHasFinished] = useState(false);
  const {
    shouldShowErrorForBlankFields,
    setShouldShowErrorForBlankFields,
    hasBlankFields,
    credentials,
    setCredentials
  } = useCredentials({
    fields
  });
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    verticalAlign: "middle",
    align: "space-between",
    gap: 2,
    paddingRight: "SP1",
    paddingTop: "SP2"
  }, hasFields && /*#__PURE__*/React.createElement(Credentials, {
    shouldShowErrorForBlankFields: shouldShowErrorForBlankFields,
    credentials: credentials,
    setCredentials: setCredentials,
    fields: fields,
    disabled: isConnecting || hasFinished
  }), /*#__PURE__*/React.createElement(Box, {
    maxWidth: "100%"
  }, isConnecting ? /*#__PURE__*/React.createElement(Button, {
    skin: "ai"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  })) : /*#__PURE__*/React.createElement(Box, {
    gap: 2
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: hasFinished,
    onClick: async () => {
      try {
        if (hasBlankFields) {
          setShouldShowErrorForBlankFields(true);
          return;
        }
        setIsConnecting(true);
        const paymentProviderId = paymentProvider.id;
        const paymentMethodTypesIds = paymentMethods.map(method => method.id);
        if (connectionType === 'oauthConnect') {
          await oauthConnect({
            paymentProvider,
            paymentMethodTypesIds,
            credentials,
            context
          });
        } else {
          await directConnect({
            paymentProviderId,
            paymentMethodTypesIds,
            credentials,
            paymentMethodTitle: paymentMethod.title,
            context
          });
        }
      } catch (e) {
        send('Payment provider was not connected due to an error');
      } finally {
        setIsConnecting(false);
        setHasFinished(true);
      }
    },
    size: "tiny",
    skin: "ai"
  }, "Connect ", paymentMethod.title), /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      send('I clicked on "Cancel".');
    },
    size: "tiny",
    priority: "secondary",
    skin: "ai",
    disabled: hasFinished
  }, "Cancel"))));
};
export const CONNECT_PAYMENT_PROVIDER_WIDGET = 'CONNECT_PAYMENT_PROVIDER_WIDGET';
//# sourceMappingURL=ConnectPaymentProviderWidget.js.map